'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

interface Props {
  routes: string[];
  delayMs?: number;
}

export function Prefetcher({ routes, delayMs = 10_000 }: Props) {
  const router = useRouter();

  useEffect(() => {
    const id = setTimeout(() => {
      for (const route of routes) {
        router.prefetch(route);
      }
    }, delayMs);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
